import { IGroupingActivityProps } from "../../properties/ActivityProperties";
import {
  parseBodyMapFromData,
  parseContentMapFromData,
  parseMaterialMapFromData,
} from "../../utilization/CatchtivityUtilization";
import ActivityBodyContent from "./body-contents/ActivityBodyContent";
import GroupingActivityMaterialContent from "./material-contents/GroupingActivityMaterialContent";
import ActivitySolveLayout from "./ActivitySolveLayout";

const GroupingActivityContent = ({
  answerMap,
  data,
  canAnswerQuestion,
  changeAnswer,
  isPreview,
  showCorrectAnswer,
  isFullScreen,
  passage,
}: IGroupingActivityProps) => {
  const contentMap = parseContentMapFromData(data);
  const groupingBodyMap = parseBodyMapFromData(data, "GROUPING");
  const groupingMaterialMap = parseMaterialMapFromData(data, "GROUPING");

  const handleGroupingAnswerOnChange = (
    answerMap: any,
    key: any,
    value: string | null,
    index: number | null,
  ) => {
    if (isPreview) return;
    if (value) {
      answerMap[key].push(value);
    } else {
      answerMap[key].splice(index, 1);
    }
    changeAnswer(answerMap);
  };

  return (
    <ActivitySolveLayout
      variant="wide"
      isFullScreen={isFullScreen}
      passage={passage}
      body={
        <ActivityBodyContent
          bodyMap={groupingBodyMap}
          templateType={"GROUPING"}
        />
      }
      interaction={
        <GroupingActivityMaterialContent
          uniqueValue={JSON.stringify(data.contentMap)}
          answerMap={answerMap}
          materialMap={groupingMaterialMap}
          contentMap={contentMap}
          checkCanAnswerQuestion={canAnswerQuestion}
          onChange={handleGroupingAnswerOnChange}
          isPreview={isPreview}
          showCorrectAnswer={showCorrectAnswer}
        />
      }
    />
  );
};

export default GroupingActivityContent;
